import { Notification } from '@ecosystem/newron-design-system/build/components/notifications/types';

export enum AccessLevel {
  Owner = 'owner',
  Viewer = 'viewer',
}
export interface ShareUser {
  accessLevel: AccessLevel;
  clientId: number;
  email: string;
  familyName?: string;
  givenName?: string;
  userId: string;
  country?: string;
  newlyAdded?: boolean;
  newlyRemoved?: boolean;
  permanent?: boolean;
}

export interface ShareUserProps extends Omit<ShareUser, 'newlyAdded' | 'newlyRemoved'> {}

export interface AvailableShareUser extends Omit<ShareUser, 'accessLevel'> {}
export interface ShareUserGroup {
  userGroupId: number;
  userGroupName: string;
  accessLevel: AccessLevel;
  clientId: number;
  usersCount?: number;
  newlyAdded?: boolean;
  newlyRemoved?: boolean;
}

export interface AvailableShareUserGroup extends Omit<ShareUserGroup, 'accessLevel'> {}

export interface ShareUserGroupProps extends Omit<ShareUserGroup, 'newlyAdded' | 'newlyRemoved'> {}

export interface ShareModalToastMessage {
  type: Notification;
  message: string | React.ReactNode;
}

export interface Client {
  clientId: number;
  clientName: string;
}
